import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2734558642/src/src/app/ui/common/side-menu.tsx");
